module.exports = __webpack_public_path__ + "static/media/banner_woman_chat_site_es.841b1428.png";